export default __webpack_public_path__ + "static/media/15t.7732dd27.jpg";